<svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="logo" clip-path="url(#clip0_0_455)">
<g id="Union" filter="url(#filter0_dd_0_455)">
<path d="M3.60352 32.3633C22.5771 34.8916 37.2368 51.0606 37.4004 70.6816C18.4328 68.1535 3.77332 51.9909 3.60352 32.3633ZM76.3965 32.3633C76.233 51.9909 61.5672 68.1535 42.5996 70.6816C42.7632 51.0606 57.4229 34.8916 76.3965 32.3633ZM39.9883 9C47.145 9 52.9627 14.8233 52.9629 21.9736C52.9629 29.1241 47.1389 34.9482 39.9883 34.9482C32.8316 34.948 27.0146 29.1239 27.0146 21.9736C27.0148 14.8235 32.8317 9.00023 39.9883 9ZM39.9883 14.1445C35.6743 14.1448 32.1594 17.6535 32.1592 21.9736C32.1592 26.294 35.6679 29.8035 39.9883 29.8037C44.3088 29.8037 47.8184 26.2941 47.8184 21.9736C47.8182 17.6533 44.3087 14.1445 39.9883 14.1445Z" fill="url(#paint0_linear_0_455)"/>
</g>
</g>
<defs>
<filter id="filter0_dd_0_455" x="-9.19649" y="4.73333" width="98.393" height="87.2817" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="8.53334"/>
<feGaussianBlur stdDeviation="6.4"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_455"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4.26667"/>
<feGaussianBlur stdDeviation="2.13333"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_0_455" result="effect2_dropShadow_0_455"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_0_455" result="shape"/>
</filter>
<linearGradient id="paint0_linear_0_455" x1="33.2142" y1="2.9253" x2="81.0317" y2="62.226" gradientUnits="userSpaceOnUse">
<stop stop-color="#F9EBDB"/>
<stop offset="1" stop-color="#F2D8B8"/>
</linearGradient>
<clipPath id="clip0_0_455">
<rect width="80" height="80" fill="white"/>
</clipPath>
</defs>
</svg>
